import React, { useState } from 'react';
import { TabletButton } from '@campfire/tablet-button';
import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from '@material-ui/core';
import { useAdminConsoleActions } from '../../admin-console-actions';

type Props = {
  open: boolean;
  onClose: () => void;
  onAddAdminSuccess: () => void;
};

export const AddAdminOnlyDialog = ({ open, onClose, onAddAdminSuccess }: Props) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');

  const { runAddAdminOnly, runAddAdminOnlyLoading } = useAdminConsoleActions();

  const isValid = firstName.trim() !== '' && lastName.trim() !== '' && email.trim() !== '';

  const handleSuccess = () => {
    onClose();
    setFirstName('');
    setLastName('');
    setEmail('');
    onAddAdminSuccess();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>
        <Typography variant='h6' gutterBottom>
          {'Add new admin'}
        </Typography>
        <Typography variant='body2'>
          {'Create a new user and make them an admin. They will receive an email to set up their account.'}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              label='First Name'
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              fullWidth
              variant='outlined'
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label='Last Name'
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              fullWidth
              variant='outlined'
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label='Email'
              type='email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
              variant='outlined'
              required
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions style={{ marginRight: '15px', marginBottom: '8px' }}>
        <TabletButton variant='text' onClick={onClose}>
          {'Cancel'}
        </TabletButton>
        <TabletButton
          variant='contained'
          color='primary'
          disabled={!isValid || runAddAdminOnlyLoading}
          onClick={() =>
            runAddAdminOnly({
              firstName: firstName.trim(),
              lastName: lastName.trim(),
              email: email.trim(),
              handleSuccess,
            })
          }
        >
          {runAddAdminOnlyLoading ? <CircularProgress size={20} /> : 'Done'}
        </TabletButton>
      </DialogActions>
    </Dialog>
  );
};
